import React, { useState, useMemo } from "react";
import { DDNav } from "../../../components/Admin/DDNav/DDNav";
import "./Repository.scss";

export const REPO_DOCS = [
  {
    code: "POL-CER-01", kind: "Política", cat: "paraguas", catLabel: "Paraguas",
    title: "Política de Conducta Empresarial Responsable",
    file: "POL-CER-01_Politica_CER_paraguas_v1.docx",
    desc: "Política paraguas que articula el compromiso de la empresa con la conducta empresarial responsable en sus propias operaciones y cadena de suministro. Marco general que aprueba al máximo nivel jerárquico los compromisos sobre los 9 riesgos del sector y los sistemas de gestión que los implementan.",
    sources: [{ t: "ocde", n: "OCDE Sec 1.1" }, { t: "onu", n: "ONU PR" }, { t: "oit", n: "OIT Decl. 1998" }],
    ocdeRef: "Sección 1.1 + Líneas Directrices IV C44", pages: "8-10",
  },
  {
    code: "POL-SST-02", kind: "Política y Procedimiento", cat: "sst", catLabel: "SST",
    title: "Política y Procedimiento de SST + Retiro Inmediato",
    file: "POL-SST-02_Politica_SST_v1.docx",
    desc: "Política integral de SST con Anexo de Procedimiento de Retiro Inmediato ante peligro crítico (OCDE 3.1.1 textual). Cubre identificación de peligros, jerarquía de controles, comité paritario, EPP, capacitación e indicadores LTIFR.",
    sources: [{ t: "oit", n: "C155 / C187" }, { t: "ocde", n: "M5 + 3.1.1" }, { t: "bw", n: "OSH Cluster" }, { t: "iso", n: "ISO 45001" }],
    ocdeRef: "Sección 3.1.1 + Módulo II.5", pages: "10-12",
  },
  {
    code: "POL-VSBG-03", kind: "Política", cat: "genero", catLabel: "Género",
    title: "Política de Prevención de Acoso Sexual y VSBG",
    file: "POL-VSBG-03_Politica_Prevencion_VSBG_v1.docx",
    desc: "Política de cero tolerancia al acoso sexual y la violencia y el acoso basados en el género. Definiciones textuales del C190 OIT, factores de riesgo Tabla 9 OCDE, procedimiento de denuncia confidencial con tiempos de respuesta y protección contra represalias.",
    sources: [{ t: "oit", n: "C190 / R206" }, { t: "ocde", n: "Tabla 9 / M2" }, { t: "bw", n: "GBV Guide" }, { t: "fla", n: "Code" }],
    ocdeRef: "Tabla 9 + Módulo II.2", pages: "9-11",
  },
  {
    code: "POL-TI-04", kind: "Política", cat: "laboral", catLabel: "Laboral",
    title: "Política contra el Trabajo Infantil",
    file: "POL-TI-04_Politica_Trabajo_Infantil_v1.docx",
    desc: "Política de cero tolerancia al trabajo infantil con definiciones textuales del C138 y C182 OIT. Procedimiento de verificación de edad y procedimiento de remediación con interés superior del niño en caso de detección.",
    sources: [{ t: "oit", n: "C138 / C182" }, { t: "ocde", n: "M1 + Tabla 2" }, { t: "onu", n: "CDN Art. 32" }, { t: "fla", n: "Code" }],
    ocdeRef: "Módulo II.1 + Tabla 2", pages: "8-10",
  },
  {
    code: "POL-TF-05", kind: "Política", cat: "laboral", catLabel: "Laboral",
    title: "Política contra Trabajo Forzoso y de Reclutamiento Responsable",
    file: "POL-TF-05_Politica_Trabajo_Forzoso_Reclutamiento_v1.docx",
    desc: "Política con cero tolerancia al trabajo forzoso, los 11 indicadores OIT, principio Employer Pays (Dhaka Principles), DD sobre agencias de reclutamiento con criterios IRIS, y procedimiento de remediación.",
    sources: [{ t: "oit", n: "C29 / P29 / C105" }, { t: "ocde", n: "M3 + Tabla 10" }, { t: "onu", n: "Dhaka Princ." }],
    ocdeRef: "Módulo II.3 + Tabla 10", pages: "10-12",
  },
  {
    code: "POL-TT-06", kind: "Política", cat: "laboral", catLabel: "Laboral",
    title: "Política de Tiempo de Trabajo",
    file: "POL-TT-06_Politica_Tiempo_Trabajo_v1.docx",
    desc: "Política sobre jornada legal, horas extra voluntarias y compensadas, descanso semanal y vacaciones. Cita textual OCDE sobre horas extra forzadas, conexión con prácticas de compra (Recuadro 4), sistema de alerta roja semanal.",
    sources: [{ t: "oit", n: "C1 / C30 / C14 / C132" }, { t: "ocde", n: "M4 + Recuadro 4" }, { t: "bw", n: "Hours Cluster" }],
    ocdeRef: "Módulo II.4 + Recuadro 4", pages: "8-10",
  },
  {
    code: "POL-SAL-07", kind: "Política", cat: "laboral", catLabel: "Laboral",
    title: "Política de Salarios y Progresión a Living Wage",
    file: "POL-SAL-07_Politica_Salarios_Living_Wage_v1.docx",
    desc: "Política de cumplimiento del salario mínimo legal, pago puntual y trazable, igualdad de remuneración (C100 OIT) y plan plurianual de progresión hacia Living Wage Anker. Incluye auditoría salarial con análisis de brecha de género.",
    sources: [{ t: "oit", n: "C95 / C100 / C131" }, { t: "ocde", n: "M7 + LD V.4(b)" }, { t: "onu", n: "Anker / GLWC" }],
    ocdeRef: "Módulo II.7 + LD OCDE V.4b", pages: "9-11",
  },
  {
    code: "POL-LSNC-08", kind: "Política", cat: "laboral", catLabel: "Laboral",
    title: "Política de Libertad Sindical y Negociación Colectiva",
    file: "POL-LSNC-08_Politica_Libertad_Sindical_v1.docx",
    desc: "Política de reconocimiento del derecho a constituir y afiliarse a sindicatos, no injerencia, negociación colectiva de buena fe y facilidades a representantes (C135 OIT). Procedimiento de denuncia de discriminación antisindical canalizado al OLGM.",
    sources: [{ t: "oit", n: "C87 / C98 / C135 / C154" }, { t: "ocde", n: "M6 + Sec 3.1.3" }, { t: "onu", n: "Decl. OIT 1998" }],
    ocdeRef: "Módulo II.6 + Sección 3.1.3", pages: "8-10",
  },
  {
    code: "PRO-OLGM-09", kind: "Procedimiento", cat: "reparacion", catLabel: "Reparación",
    title: "Procedimiento del Mecanismo de Reclamación a Nivel Operativo (OLGM)",
    file: "PRO-OLGM-09_Procedimiento_Mecanismo_Reclamacion_v1.docx",
    desc: "Procedimiento del OLGM que cumple los 7 criterios de los Principios Rectores ONU 31 (legitimidad, accesibilidad, predictibilidad, equidad, transparencia, compatibilidad con derechos, aprendizaje). Diferencia función de alerta vs reparación (Recuadro 8 OCDE).",
    sources: [{ t: "ocde", n: "Sec 6 + Rec 8" }, { t: "onu", n: "PR 29-31" }, { t: "fla", n: "Code" }],
    ocdeRef: "Sección 6.1.1 + Líneas Directrices IV.A6", pages: "10-12",
  },
  {
    code: "POL-DISC-10", kind: "Política", cat: "genero", catLabel: "Género",
    title: "Política de No Discriminación e Igualdad de Oportunidades",
    file: "POL-DISC-10_Politica_No_Discriminacion_v1.docx",
    desc: "Política de no discriminación cubriendo todos los motivos protegidos (género, origen, religión, edad, embarazo, discapacidad, condición migratoria, afiliación sindical). Auditoría salarial anual con análisis de brechas e indicadores de equidad.",
    sources: [{ t: "oit", n: "C100 / C111 / C156 / C159" }, { t: "ocde", n: "Tabla 2 + M7" }, { t: "fla", n: "Code" }],
    ocdeRef: "Tabla 2 + Módulo II.7", pages: "9-11",
  },
];

const REPO_CATS = {
  paraguas:  { label: "Paraguas · Política CER",             icon: "🌐", desc: "Documento marco que articula los compromisos generales de DD" },
  laboral:   { label: "Derechos laborales fundamentales",     icon: "👥", desc: "Trabajo infantil, forzoso, tiempo, salarios, libertad sindical" },
  sst:       { label: "SST y bienestar",                      icon: "🛡", desc: "Seguridad y salud ocupacional, condiciones de trabajo" },
  genero:    { label: "Género y no discriminación",           icon: "⚖", desc: "VSBG, igualdad, equidad" },
  reparacion:{ label: "Reparación y diálogo",                 icon: "🤝", desc: "Mecanismos de reclamación y atención de impactos" },
};

const CAT_ORDER = ["paraguas", "laboral", "sst", "genero", "reparacion"];
const STD_OPTS  = ["ocde", "oit", "bw", "fla", "onu", "iso"];

export function Repository() {
  const [filterCat, setFilterCat] = useState("");
  const [filterStd, setFilterStd] = useState("");
  const [filterQ,   setFilterQ]   = useState("");
  const [preview,   setPreview]   = useState(null);

  const filtered = useMemo(() => {
    const q = filterQ.toLowerCase().trim();
    return REPO_DOCS.filter((d) => {
      if (filterCat && d.cat !== filterCat) return false;
      if (filterStd && !d.sources.some((s) => s.t === filterStd)) return false;
      if (q && !`${d.title} ${d.desc} ${d.code}`.toLowerCase().includes(q)) return false;
      return true;
    });
  }, [filterCat, filterStd, filterQ]);

  const byCat = useMemo(() => {
    const map = {};
    filtered.forEach((d) => { if (!map[d.cat]) map[d.cat] = []; map[d.cat].push(d); });
    return map;
  }, [filtered]);

  return (
    <div className="repo-page">
      <DDNav />
      <div className="repo-content">
      <div className="repo-ph">
        <div>
          <h1 className="repo-title">Repositorio de Políticas y Procedimientos</h1>
          <div className="repo-sub">
            10 plantillas Word · OCDE 2021 · OIT · Better Work · FLA · ONU · ISO · listas para adaptar a tu fábrica
          </div>
        </div>
      </div>

      <div className="repo-intro">
        <h3>📚 Cómo usar este repositorio</h3>
        <p>
          Cada documento es una <b>plantilla profesional</b> redactada con base en estándares internacionales
          reconocidos (OCDE, OIT, Better Work, FLA, ONU). La fábrica descarga el archivo Word, completa los
          marcadores <code>{"{{ASÍ}}"}</code> con su contexto y lo aprueba al máximo nivel jerárquico conforme a
          las Líneas Directrices OCDE IV, Comentario 44.
        </p>
        <p>
          Cada plantilla incluye: <b>marco normativo de referencia</b> con citas textuales, <b>definiciones
          operacionales</b>, <b>compromisos de la empresa</b>, <b>procedimientos paso a paso</b>,{" "}
          <b>indicadores de seguimiento</b> y una <b>tabla de historial de revisiones</b>.
        </p>
        <div className="repo-warning">
          <b>⚠ Nota:</b> estas plantillas no sustituyen el asesoramiento legal. Cada fábrica debe verificar el
          cumplimiento con su legislación nacional antes de aprobar el documento.
        </div>
      </div>

      {/* Filtros */}
      <div className="repo-filters">
        <span className="lbl">Filtrar por:</span>
        <select value={filterCat} onChange={(e) => setFilterCat(e.target.value)}>
          <option value="">Todas las categorías</option>
          <option value="paraguas">Paraguas (Política CER)</option>
          <option value="laboral">Derechos laborales</option>
          <option value="sst">SST y bienestar</option>
          <option value="genero">Género y no discriminación</option>
          <option value="reparacion">Reparación y diálogo</option>
        </select>
        <select value={filterStd} onChange={(e) => setFilterStd(e.target.value)}>
          <option value="">Todos los estándares</option>
          {STD_OPTS.map((s) => (
            <option key={s} value={s}>{s.toUpperCase()}</option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Buscar por palabra clave..."
          value={filterQ}
          onChange={(e) => setFilterQ(e.target.value)}
        />
        <span className="repo-count">{filtered.length} de {REPO_DOCS.length} documentos</span>
      </div>

      {/* Cards */}
      {filtered.length === 0 ? (
        <div className="repo-empty">
          <div className="ico">📭</div>
          <p>No hay documentos que coincidan con los filtros</p>
        </div>
      ) : (
        CAT_ORDER.filter((c) => byCat[c]).map((c) => {
          const meta = REPO_CATS[c];
          return (
            <div key={c}>
              <div className="repo-cat-header">
                <h3>{meta.icon} {meta.label}</h3>
                <span className="num">{byCat[c].length}</span>
                <span className="meta">{meta.desc}</span>
              </div>
              <div className="repo-grid">
                {byCat[c].map((d) => (
                  <RepoCard key={d.code} doc={d} onPreview={() => setPreview(d)} />
                ))}
              </div>
            </div>
          );
        })
      )}

      {/* Preview modal */}
      {preview && (
        <div className="repo-modal-overlay" onClick={() => setPreview(null)}>
          <div className="repo-modal" onClick={(e) => e.stopPropagation()}>
            <div className="repo-modal-hd">
              <div>
                <div className="repo-modal-kind">{preview.kind}</div>
                <div className="repo-modal-title">{preview.title}</div>
                <div className="repo-modal-code">{preview.code}</div>
              </div>
              <button className="repo-modal-close" onClick={() => setPreview(null)}>✕</button>
            </div>
            <div className="repo-modal-body">
              <p className="repo-modal-desc">{preview.desc}</p>
              <div className="repo-modal-row">
                <span className="lbl">Referencia OCDE:</span>
                <span>{preview.ocdeRef}</span>
              </div>
              <div className="repo-modal-row">
                <span className="lbl">Extensión estimada:</span>
                <span>{preview.pages} páginas Word</span>
              </div>
              <div className="repo-modal-row">
                <span className="lbl">Fuentes:</span>
                <div className="repo-modal-sources">
                  {preview.sources.map((s) => (
                    <span key={s.t} className={`repo-source-badge ${s.t}`}>{s.n}</span>
                  ))}
                </div>
              </div>
              <div className="repo-modal-info">
                📁 Archivo: <code>{preview.file}</code>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

function RepoCard({ doc: d, onPreview }) {
  return (
    <div className="repo-card">
      <div className="repo-card-hd">
        <div className="repo-card-kind">{d.kind}</div>
        <div className="repo-card-title">{d.title}</div>
        <div className="repo-card-code">{d.code}</div>
      </div>
      <div className="repo-card-body">
        <div className="repo-card-desc">{d.desc}</div>
        <div className="repo-card-sources">
          {d.sources.map((s) => (
            <span key={s.t + s.n} className={`repo-source-badge ${s.t}`}>{s.n}</span>
          ))}
        </div>
        <div className="repo-card-meta">
          <span>📐 {d.ocdeRef}</span>
          <span>📄 {d.pages} páginas Word</span>
        </div>
      </div>
      <div className="repo-card-foot">
        <span className="repo-btn-dl repo-btn-dl--soon" title="Los archivos Word se distribuyen con el paquete de implementación">
          📥 Word · próximamente
        </span>
        <button className="repo-btn-preview" onClick={onPreview}>👁 Preview</button>
      </div>
    </div>
  );
}
